import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div className="pt-24">
      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-br from-[#FAFFEE] to-[#EDEDFE] relative overflow-hidden">
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-2 text-[#0C6951] font-semibold uppercase tracking-wider">
              <Link to="/" className="hover:text-[#004534]">Home</Link>
              <ChevronRight className="w-4 h-4" />
              Privacy Policy
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-[#004534] mt-4">
              Privacy Policy
            </h1>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto prose prose-lg">
            <p className="text-[#807979] leading-relaxed mb-8">
              Last updated: January 2026
            </p>
            
            <div className="space-y-8">
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">1. Information We Collect</h2>
                <p className="text-[#807979] leading-relaxed">
                  We collect information you provide directly to us, such as when you create an account, make a purchase, contact us for support, or interact with our services. This may include your name, email address, phone number, and business information.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">2. How We Use Your Information</h2>
                <p className="text-[#807979] leading-relaxed">
                  We use the information we collect to provide, maintain, and improve our services, process transactions, send you technical notices and support messages, and respond to your comments and questions.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">3. Information Sharing</h2>
                <p className="text-[#807979] leading-relaxed">
                  We do not share your personal information with third parties except as described in this policy. We may share information with service providers who assist us in providing our services, or when required by law.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">4. Data Security</h2>
                <p className="text-[#807979] leading-relaxed">
                  We take reasonable measures to help protect your personal information from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">5. Cookies</h2>
                <p className="text-[#807979] leading-relaxed">
                  We use cookies and similar technologies to collect information about your browsing activities and to personalize your experience on our website.
                </p>
              </div>
              
              <div>
                <h2 className="text-2xl font-bold text-[#004534] mb-4">6. Contact Us</h2>
                <p className="text-[#807979] leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us at support@mldcagro.com.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
